import React, {useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";

import css from './PricePackSingleComponent.module.css';
import {packsService} from "../../../services/settings-services";
import { packsActions } from '../../../store/slices/settings-slices';
import { toast } from 'react-toastify';


const PricePackSingleComponent = ({pack}) => {
    const dispatch = useDispatch();
    const {id, name, pricePerDay} = pack;
    const {i18n} = useTranslation();
    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name["en"];
    const [isLoading, setIsLoading] = useState(false);

    const [price, setPrice] = useState(pricePerDay);
    const debounceTimer = useRef(null);

    const handlePriceChange = async (e) => {
        const newPrice = e.target.value;
        setPrice(newPrice);

        // Clear existing timer
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        // Set new timer
        debounceTimer.current = setTimeout(async () => {
            if (newPrice !== pricePerDay) {
                const dataForBack = {"pricePerDay": Number(newPrice)};
                try {
                    setIsLoading(true);
                    await packsService.changePricePack(id, dataForBack);
                    toast.success('Price is updated!');
                } catch (error) {
                    console.error('Error updating price:', error);
                    toast.error('Error updating price!');
                } finally {
                    setIsLoading(false);
                    dispatch(packsActions.changeTrigger());
                }
            }
        }, 800);
    };

    return (
        <div className={css.wrap}>
            <div className={css.name}>{displayName}</div>

            <div className={css.price}>
                <input
                    type="number"
                    disabled={isLoading}
                    style={isLoading ? {opacity: 0.5} : {}}
                    placeholder={isLoading ? 'Loading...' : ''}
                    value={price}
                    onChange={handlePriceChange}
                />
            </div>
        </div>
    );
};

export {PricePackSingleComponent};
